export default __webpack_public_path__ + "static/media/luiz-filipe-modal.2372f402.jpg";